import { Col } from "react-bootstrap";

const NotAllowed = () => {
  const logo2 = process.env.PUBLIC_URL + "/img/vaghfnama-logo.png";

  return (
    <>
      <Col md={5} className=" p-5 bg-white full-height">
        <div className="login-main-left">
          <div className="text-center mb-5 login-main-left-header pt-4">
            <a href="/">
              <img src={logo2} width="40%" className="img-fluid" alt="LOGO" />
            </a>
            <p
              className="mt-5"
              style={{
                fontSize: "20px",
                color: "red",
              }}
            >
              شما اجازه دسترسی به این صفحه را ندارید.
            </p>
          </div>

          <div className="text-center mt-4">
            <p className="light-gray">
              در کانال{" "}
              <a
                href="https://eitaa.com/joinchat/2880832496C155a6954d3"
                className="text-primary-custom"
                target="_blank"
              >
                پشتیبانی
              </a>{" "}
              وقف نما در ایتا عضو شوید.
            </p>
            <p className="light-gray">
              حساب کاربری ندارید؟ <a href="/auth/register">ثبت نام</a>
            </p>
            {/* <p className="light-gray">
              <Link to="/auth/forget-password">فراموشی رمزعبور</Link>
            </p> */}
          </div>
        </div>
      </Col>
    </>
  );
};

export default NotAllowed;
